import { AbstractControl } from '@angular/forms';

export function setControlDisabled(control?: AbstractControl, disabled = true): void {
  const action = disabled ? 'disable' : 'enable';
  control?.[action]();
}
